import { Button } from '@/components/ui/button';

export const AppErrorFallback = () => (
  <div className="flex h-screen items-center justify-center bg-white">
    <div className="flex flex-col items-center space-y-6 p-8">
      <h2 className="text-3xl font-semibold text-center" data-cy="page-title">
        Something went wrong
      </h2>
      <p className="text-muted-foreground text-center text-m">
        Reload the page or contact support if the problem continues.
      </p>
      <div className="flex gap-4">
        <Button onClick={() => window.location.reload()} className="px-6 py-2">
          Reload page
        </Button>
        <Button
          onClick={() => (window.location.href = 'mailto:support@mavue.de')}
          variant="outline"
          className="px-6 py-2"
        >
          Contact support
        </Button>
      </div>
    </div>
  </div>
);
